import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Heart, Plus } from "lucide-react";

export default function NonProfits() {
  const { t } = useI18n();

  return (
    <section data-testid="nonprofits" className="clay p-6 md:p-7">
      <div className="flex items-start gap-3 mb-5">
        <div className="w-12 h-12 rounded-2xl bg-[color:var(--coral)]/10 text-[color:var(--coral)] flex items-center justify-center">
          <Heart className="w-6 h-6" />
        </div>
        <div>
          <p className="eyebrow">{t("help_community_eyebrow")}</p>
          <h3 className="text-2xl font-semibold mt-0.5" style={{ fontFamily: "Outfit" }}>
            {t("help_community_title")}
          </h3>
          <p className="text-sm text-[color:var(--ink-2)] mt-0.5">{t("help_community_subtitle")}</p>
        </div>
      </div>

      <a
        href="/#suggestions"
        data-testid="np-add-box"
        className="relative block rounded-2xl p-8 text-center overflow-hidden transition-transform hover:-translate-y-1 border-2 border-dashed border-[color:var(--coral)]/40"
        style={{ background: "linear-gradient(135deg, #fde2d6 0%, #fbeee6 60%, #ffffff 100%)" }}
      >
        <div className="w-14 h-14 rounded-2xl bg-[color:var(--coral)] text-white flex items-center justify-center mx-auto mb-3 shadow-sm">
          <Plus className="w-7 h-7" />
        </div>
        <p className="text-lg font-bold text-[color:var(--ink)]" style={{ fontFamily: "Outfit" }}>
          {t("np_add_title")}
        </p>
        <p className="text-sm text-[color:var(--ink-2)] mt-1 max-w-md mx-auto">
          {t("np_add_sub")}
        </p>
        <span className="pill px-4 py-2 text-sm font-semibold inline-flex items-center gap-1.5 text-white shadow-sm mt-4 bg-[color:var(--coral)]">
          <Plus className="w-4 h-4" />
          {t("np_add_cta")}
        </span>
      </a>

      <p className="text-[11px] text-[color:var(--ink-2)] mt-4 italic text-center">
        {t("help_community_footer_note")}
      </p>
    </section>
  );
}
